let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("80ixL")).then(() => parcelRequire('j0spP'));